module.exports = __webpack_public_path__ + "img/167.bc2e1118.gif";